import axios from 'axios';

import { MainUrl } from "../constants"

const API_URL = `${MainUrl}/station`

export const getStation = async (token, stationId) => {
    

  const response = await axios.get(`${API_URL}/${stationId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
};


export const GetStationsByIdGroup = async (token, stationId) => {
    

  const response = await axios.post(`${API_URL}/stations_by_group_id/${stationId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
};